module.exports = {
      id: "nutstore-3-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "images/js_src_vue/common/sprite.61ac148b.svg#nutstore-3-icon-usage",
      toString: function () {
        return this.url;
      }
    }